import '../styles/styles.scss';
import './modules/header';
import './modules/progres';
import './modules/articles';
import './modules/slideshow';
import './modules/slideshow-resize';